import { specialtyQueryOptions } from '@services/queries/specialtyQueries';
import { store } from '@store';
import { useQuery } from '@tanstack/react-query';
import { FilterListHelpers } from '@utils/filterListHelpers';
import { SpecialtyListItemData } from 'chaika-frontend-types/frontend-cms';
import { SpecialtyStatus } from 'chaika-enums';
import { Optional } from 'chaika-common-types';

interface Data {
    specialties: SpecialtyListItemData[];
    filteredSpecialties: SpecialtyListItemData[];
    getFilteredSpecialties(params: FilterParams): SpecialtyListItemData[];
    getSpecialtyById(id: string): Optional<SpecialtyListItemData>;
}

interface FilterParams {
    ids?: string[];
    status?: SpecialtyStatus;
    isDiagnostic?: boolean;
    name?: string;
}

export function useSpecialties(params: FilterParams = {}, locale = store.authUser.selectedLanguage): Data {
    const { filterFieldValueIncludesString, filterFieldValueByArray, filterFieldValue } = FilterListHelpers;
    const { data } = useQuery(specialtyQueryOptions.list(locale));
    const specialties = data ?? [];

    function getFilteredSpecialties(params: FilterParams): SpecialtyListItemData[] {
        return specialties.filter(
            s =>
                filterFieldValueIncludesString<SpecialtyListItemData>(s, params.name, 'name') &&
                filterFieldValueByArray(s, params.ids, 'id') &&
                filterFieldValue(s, params.status, 'status') &&
                filterFieldValue(s, params.isDiagnostic, 'isDiagnostic'),
        );
    }

    return {
        getFilteredSpecialties,
        specialties,
        getSpecialtyById: id => specialties.find(s => s.id === id),
        filteredSpecialties: specialties.filter(
            s =>
                filterFieldValueIncludesString<SpecialtyListItemData>(s, params.name, 'name') &&
                filterFieldValueByArray(s, params.ids, 'id') &&
                filterFieldValue(s, params.status, 'status') &&
                filterFieldValue(s, params.isDiagnostic, 'isDiagnostic'),
        ),
    };
}
